var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"root lx-back-link",on:{"click":_vm.onClick}},[_c('lx-icon',{staticClass:"back-icon",attrs:{"icon":"arrow-back","size":"11"}}),_c('span',[_vm._v("Back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }